import { render, staticRenderFns } from "./VerifyMail.vue?vue&type=template&id=ff3a8ccc&style=background-color%3Ablack%3B&"
import script from "./VerifyMail.vue?vue&type=script&lang=js&"
export * from "./VerifyMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports